import dialog from './dialog.hbs';
import './dialog.scss'

export default () => dialog()
